import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import {inRange} from 'helpers/common-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    onBlur(rawValue) {
        const {rangeLimits, positionsGroup} = this.props;

        const value = NumberHelper.prepareInt(rawValue)
            .limitByRange(rangeLimits.getMin(), rangeLimits.getMax(), rangeLimits.getMin(), rangeLimits.getMax())
            .get();

        this.props.dispatch(Action.set('RangeOfOutcomesByPositions', positionsGroup, value));
    }

    render() {
        const {rangeOfOutcomesByPositions, positionsGroup, testId} = this.props;
        const value = rangeOfOutcomesByPositions.getRangeOfOutcomesPctByPositions(positionsGroup);

        return <InputText value={value} keyboard="number" onBlur={::this.onBlur} testId={testId} />;
    }
}

function mapStatesToProps(state) {
    const {rangeOfOutcomesByPositions} = state;

    return {
        rangeOfOutcomesByPositions,
    };
}

export default connect(mapStatesToProps)(FilterInput);
